import React from 'react'
import PropTypes from 'prop-types'

import clsx from 'clsx'

import {
  Typography,
  IconButton,
  Divider,
  Tooltip,
  makeStyles,
} from '@material-ui/core'

import { DeleteOutlineOutlined } from '@material-ui/icons'

import helpers from 'helpers'
import styles from './styles'

const useStyles = makeStyles(styles)

const CartItem = ({
  item,
  component: Component = 'div',
  divider = false,
  disableActions = false,
  className,
  onClickRemove = () => {},
  ...rest
}) => {
  const classes = useStyles()

  const price = React.useMemo(
    () => helpers.currency(item.price, { hideSymbol: true }),
    [item],
  )

  return (
    <>
      <Component className={clsx(classes.root, className)} {...rest}>
        <div className={classes.nameAndDescription}>
          <Typography variant="h4" color="primary" className={classes.name}>
            {item.name}
          </Typography>

          <Typography color="textSecondary" className={classes.description}>
            {item.description}
          </Typography>
        </div>

        <div className={classes.priceAndDeleteButton}>
          <div className={classes.priceBox}>
            <Typography className={classes.price}>
              <Typography component="span" className={classes.pricePrefix}>
                R$
              </Typography>
              {price}
            </Typography>

            <Typography color="textSecondary" className={classes.periodicity}>
              {helpers.plans.formatPeriodicityCheckout(item.periodicity)}
            </Typography>
          </div>

          {!disableActions && (
            <Tooltip title="Remover item">
              <IconButton onClick={event => onClickRemove(event, item)}>
                <DeleteOutlineOutlined />
              </IconButton>
            </Tooltip>
          )}
        </div>
      </Component>

      {divider && <Divider />}
    </>
  )
}

CartItem.propTypes = {
  item: PropTypes.object,
  component: PropTypes.object,
  divider: PropTypes.bool,
  disableActions: PropTypes.bool,
  className: PropTypes.string,
  onClickRemove: PropTypes.func,
}

export default CartItem
